import { render } from "./ProfilePopover.vue?vue&type=template&id=402d1433"
import script from "./ProfilePopover.vue?vue&type=script&lang=js"
export * from "./ProfilePopover.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__